'use strict'
module.exports = () => {
	const primaryNav = document.querySelector('#header ul.nav')
	const navBtn = document.querySelector('#header .mobile-nav')
	const secondaryNav = document.querySelector('#header ul.nav.secondary')
	const navBtnLabel = navBtn.querySelector('span')

	let navOpen = false
	navBtn.addEventListener('click', e => {
		e.preventDefault()

		if(navOpen === false){
			if(getComputedStyle(navBtnLabel).display === 'block'){
				primaryNav.style.display = 'block'
			}
			else{
				secondaryNav.style.display = 'block'
			}

			navOpen = true
		}
		else{
			if(getComputedStyle(navBtnLabel).display === 'block'){
				primaryNav.style.display = 'none'
			}
			else{
				secondaryNav.style.display = 'none'
			}
			navOpen = false
		}

	})

}
